var module = angular.module('octopusApp.shared');

module.controller('ImportEntityDialogController', function($scope, $uibModalInstance, busy, $q, entityType, doImport){
  var isSaving = $scope.isSaving = busy.create();

  $scope.entityJson = '';

  $scope.save = function() {
    var entity;

    try {
      entity = JSON.parse($scope.entityJson);
      if (!entity || !entity.$Meta || entity.$Meta.Type !== entityType) {
        throw new Error("The data is not a valid " + entityType + ".");
      }
      entity = _.omit(entity, ['Id', '$Meta']);
    } catch (e) {
      isSaving.showError(e.message || e);
      return;
    }

    isSaving.promise(doImport(entity).then(function(){
      $uibModalInstance.close();
    }));
  };

  $scope.close = function() {
    $uibModalInstance.close();
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/controllers/import_entity_dialog_controller.js
// module id = 581
// module chunks = 1